import React from "react";
import { Link, useNavigate } from "react-router-dom";
const TeamSection = () => {
  const navigate = useNavigate();
  const teamMembers = [
    {
      img: "img/team-1.jpg",
      name: "Instructor Name",
      designation: "Designation",
    },
    {
      img: "img/team-2.jpg",
      name: "Instructor Name",
      designation: "Designation",
    },
    {
      img: "img/team-3.jpg",
      name: "Instructor Name",
      designation: "Designation",
    },
    {
      img: "img/team-4.jpg",
      name: "Instructor Name",
      designation: "Designation",
    },
  ];

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Instructors
          </h6>
          <h1 className="mb-5">Expert Instructors</h1>
        </div>
        <div className="row g-4">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.2 * index}s`}
            >
              <div className="team-item bg-light">
                <div className="overflow-hidden">
                  <img className="img-fluid" src={member.img} alt="" />
                </div>
                <div
                  className="position-relative d-flex justify-content-center"
                  style={{ marginTop: "-23px" }}
                >
                  <div className="bg-light d-flex justify-content-center pt-2 px-1">
                    <a className="btn btn-sm-square btn-primary mx-1" href="">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a className="btn btn-sm-square btn-primary mx-1" href="">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a className="btn btn-sm-square btn-primary mx-1" href="">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div className="text-center p-4">
                  <h5 className="mb-0">{member.name}</h5>
                  <small>{member.designation}</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;
